export default {
	'invoice-type': 'نوع الفاتورة'
}